module.exports = __webpack_public_path__ + "img/apex to apex.224df545.png";